import { useAuth, useOrganization } from '@clerk/clerk-react'
import { useQuery } from '@tanstack/react-query'
import { QUERY_GC_TIME_MS, QUERY_STALE_TIME_MS } from '@/config/constants'
import { billingKeys } from '@/lib/queryKeys'
import { fetchCurrentUsage } from '../api/api'

export function useCurrentUsageQuery(enabled: boolean) {
  const { getToken } = useAuth()
  const { organization } = useOrganization()

  return useQuery({
    queryKey: billingKeys.currentUsage(organization?.id ?? ''),
    queryFn: async ({ signal }) => {
      const token = await getToken()
      if (!token) throw new Error('No auth token available')
      return fetchCurrentUsage(token, signal)
    },
    enabled: enabled && !!organization?.id,
    staleTime: QUERY_STALE_TIME_MS,
    gcTime: QUERY_GC_TIME_MS,
    refetchOnWindowFocus: false,
  })
}
